import React, { FunctionComponent } from 'react'
import Label from '../Basic'

export type PearlLabelProps = {
    /** label text */
    children: string
}

const PearlLabel: FunctionComponent<PearlLabelProps> = ({ children }) => (
    <Label backgroundColor="pearl" fontColor="onyx">
        {children}
    </Label>
)
export default PearlLabel
